import { Feature } from '@tekman/onmat/models';
import { FeaturitProperties } from './featurit-properties.model';

export class FeaturitEventActivity<T> extends FeaturitProperties {
  [key: string]: string | number | boolean | Array<string> | undefined;

  constructor(_obj: any) {
    super();
    Object.keys(_obj).forEach((key: string) => {
      if (key === 'activity') {
        this['activity_id'] = _obj.activity?.id;
        this['activity_title'] = _obj.activity?.title;
        this['activity_typology'] = _obj.activity?.typology?.styleId;
        this['activity_subtypology'] = _obj.activity?.typology?.title;
        this['step_id'] = _obj.activity?.step?.id;
        this['step_title'] = _obj.activity?.step?.title;
        this['activity_features'] = _obj.activity?.features?.map((f: Feature) => f.name);
        return;
      }
      this[key] = _obj[key];
    });
  }
}
